import Autolinker from 'autolinker'

const isMobileViewport = window.innerWidth < 992

class Forum {
    initialize() {
        const that = this

        $('.page-forum').on('click', '.thread-closed > .comment-wrapper .comment-detail', this.openThread)
        $('.page-forum').on('click', '.thread-closed > .comment-wrapper .comment-counts', this.openThread)

        $('.form-thread-create').submit(this.disableBtnOnSubmit)
        $('.comment-user-input--form:not(.form-thread-create) .btn-send').click(this.submitComment)
        $('.comment-user-input--text').change(function() {
            $(this).parent().find('.comment-text .comment-message').click()
        })

        // if mobile viewport, open thread detail page
        $('.thread-wrapper.has-thread-detail .comment-detail').click(this.openThreadDetail)
        $('.thread-wrapper.has-thread-detail .comment-counts').click(this.openThreadDetail)

        // edit a comment
        $('#modal-edit-comment').on('show.bs.modal', function(event) {
            that.editComment(event, this)
        })
        $('#modal-edit-comment').on('shown.bs.modal', this.growComment)

        // delete a comment
        $('#modal-delete-comment').on('show.bs.modal', this.deleteComment)

        // edit a thread
        $('#modal-edit-thread').on('show.bs.modal', function(event) {
            that.editThread(event, this)
        })
        $('#modal-edit-thread').on('shown.bs.modal', this.growThread)

        // delete a thread
        $('#modal-delete-thread').on('show.bs.modal', this.deleteThread)

        // display only threads created by coach
        $('.filter-activity').change(this.filterThreadsByOwnership)

        // show/hide comments
        $('.all-comments').click(this.toggleComments)

        // display and scroll to notification model
        $('.thread-list-aside .thread-wrapper').click((e) => this.clickOnNotification(e))

        $('.comment-mention').click(function() {
            const form = $(this).closest('form')
            const textarea = $(form).find('.comment-user-input--text')
            const textWrapper = $(form).find('.comment-text')

            textWrapper.hide()
            textarea.css('display', 'inline-block')
            textarea.html(textarea.html() + '@')

            // set curset at the end of contenteditable element
            textarea.focus()
            document.execCommand('selectAll', false, null)
            document.getSelection().collapseToEnd()
        })

        $('.comment-message').click(function() {
            const form = $(this).closest('form')
            const textarea = $(form).find('.comment-user-input--text')
            const textWrapper = $(form).find('.comment-text')

            textWrapper.hide()
            textarea.css('display', 'inline-block')
            textarea.focus()
        })

        $('.comment-user-input--text:not(.thread)').focusout(function() {
            const form = $(this).closest('form')
            const textWrapper = $(form).find('.comment-text')

            if ($(this)[0].innerHTML == '') {
                $(this).hide()
                textWrapper.show()
            }
        })

        $('.comment-user-input--file-icon-wrapper').click(function() {
            const fileInput = $(this).parents('.comment-user-input--form').find('input[type=file]')

            if ($(this).parents('.comment-user-input--form').find('.file-input').length == 0) {
                that.createFileInput(fileInput)
            }

            fileInput.click()
        })

        // $('input[type=file]').on('fileremoved', function(event, id, index) {
        //     var errorItem = $(this).parents(".comment-user-input--form").find(".file-error-message ul li");

        //     console.log(errorItem);

        //     if(errorItem.length == 1) {
        //         $(this).parents(".comment-user-input--form").find(".file-error-message .close").click();
        //         $(this).parents(".comment-user-input--form").find(".file-input").removeClass("has-error");
        //     }
        // });

        lightbox.option({
            alwaysShowNavOnTouchDevices: true,
            albumLabel: lang.get('Image %1 of %2')
        })

        that.createFileInput($('#files-thread-modal'))

        // parse links
        this.linkifyText()

        // parse mentions
        this.parseCommentMentions()

        this.registerMentions()

        $("#thread-title").click(function() {
            $("#thread-title-emoji").show()
            $("#thread-message-emoji").hide()
        })

        $("#thread-message").click(function() {
            $("#thread-title-emoji").hide()
            $("#thread-message-emoji").show()
        })
    }

    createFileInput(fileInput, options = {}) {
        const that = this

        fileInput.fileinput('destroy')

        fileInput
            .fileinput({
                showZoom: false,
                showUpload: false,
                showCancel: false,
                showRemove: false,
                showCaption: false,
                dropZoneEnabled: false,
                retryErrorUploads: false,
                removeFromPreviewOnError: true,
                showUploadedThumbs: true,
                uploadUrl: '/site/test-upload',
                allowedPreviewTypes: ['image'],
                allowedFileExtensions: ['jpg', 'jpeg', 'png', 'pdf'],
                language: _.get(window, 'locale', 'cs'),
                maxFileSize: 10000,
                layoutTemplates: {
                    main1:
                        '<span class="file-title">' +
                        lang.get('Attach file') +
                        '</span>\n{preview}\n' +
                        '<div class="kv-upload-progress kv-hidden"></div><div class="clearfix"></div>\n' +
                        '<div class="input-group {class}">\n' +
                        '  {caption}\n' +
                        '</div>',
                    main2:
                        '<span class="file-title">' +
                        lang.get('Attach file') +
                        '</span>{preview}\n<div class="kv-upload-progress hide"></div>',
                    size: '<samp>{sizeText}</samp>',
                    actions:
                        '<div class="file-actions">\n' +
                        '    <div class="file-footer-buttons">\n' +
                        '        {delete}' +
                        '    </div>\n' +
                        '    <div class="clearfix"></div>\n' +
                        '</div>',
                    preview:
                        '<div class="file-preview {class}">\n' +
                        '    <div class="{dropClass}">\n' +
                        '    <div class="file-preview-thumbnails">\n' +
                        '    </div>\n' +
                        '    {browse}' +
                        '    <div class="clearfix"></div>' +
                        '    <div class="file-preview-status text-center text-success"></div>\n' +
                        '    <div class="kv-fileinput-error"></div>\n' +
                        '    </div>\n' +
                        '</div>',
                    btnBrowse:
                        '<div tabindex="500" class="{css}"{status}><svg width="28px" height="25px" viewBox="0 0 28 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g id="Android-APP-wireframes" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="4" transform="translate(-296.000000, -521.000000)" fill="#FFFFFF" fill-rule="nonzero"> <g id="Button/Primary/New-Photo" transform="translate(280.000000, 504.000000)"> <path d="M44,23.25 L44,39.3214286 C44,40.8002232 42.8242188,42 41.375,42 L18.625,42 C17.1757812,42 16,40.8002232 16,39.3214286 L16,23.25 C16,21.7712054 17.1757812,20.5714286 18.625,20.5714286 L23.4375,20.5714286 L24.1101563,18.7354911 C24.4929688,17.6919643 25.471875,17 26.565625,17 L33.4289063,17 C34.5226563,17 35.5015625,17.6919643 35.884375,18.7354911 L36.5625,20.5714286 L41.375,20.5714286 C42.8242188,20.5714286 44,21.7712054 44,23.25 Z M36.5625,31.2857143 C36.5625,27.5915179 33.6203125,24.5892857 30,24.5892857 C26.3796875,24.5892857 23.4375,27.5915179 23.4375,31.2857143 C23.4375,34.9799107 26.3796875,37.9821429 30,37.9821429 C33.6203125,37.9821429 36.5625,34.9799107 36.5625,31.2857143 Z M34.8125,31.2857143 C34.8125,33.9921875 32.6523438,36.1964286 30,36.1964286 C27.3476562,36.1964286 25.1875,33.9921875 25.1875,31.2857143 C25.1875,28.5792411 27.3476562,26.375 30,26.375 C32.6523438,26.375 34.8125,28.5792411 34.8125,31.2857143 Z" id="foto"></path> </g> </g> </g> </svg></div>'
                },
                previewFileIconSettings: {
                    pdf:
                        '<svg width="28px" height="36px" viewBox="0 0 28 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>FEBBB219-DE67-469C-8384-D2544C3723C4</title> <g id="Android-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="2020-05_diskuse-priloha" transform="translate(-30.000000, -286.000000)"><g id="file-extension" transform="translate(30.000000, 286.000000)"><path d="M1.77556129,0 L20.1318194,0 L27.9943097,7.83196129 L27.9943097,34.1879484 C27.9943097,35.1525032 27.2122065,35.9337935 26.2484645,35.9337935 L1.77556129,35.9337935 C0.811819355,35.9337935 0.029716129,35.1525032 0.029716129,34.1879484 L0.029716129,1.74584516 C0.029716129,0.781290323 0.811909677,0 1.77556129,0 Z" id="Path" fill="#E2574C" fill-rule="nonzero"></path> <text id="PDF" font-family="Nunito-Black, Nunito" font-size="10" font-weight="700" line-spacing="16" fill="#FFFFFF"><tspan x="3.86" y="21">PDF</tspan></text> <path d="M27.9691097,7.85634839 L21.8838968,7.85634839 C20.9201548,7.85634839 20.1380516,7.07424516 20.1380516,6.11050323 L20.1380516,0.0174322581 L27.9691097,7.85634839 Z" id="Path" fill="#B53629" fill-rule="nonzero"></path></g></g></g></svg>',
                    doc:
                        '<svg width="28px" height="36px" viewBox="0 0 28 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>FEBBB219-DE67-469C-8384-D2544C3723C4</title> <g id="Android-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="2020-05_diskuse-priloha" transform="translate(-30.000000, -286.000000)"><g id="file-extension" transform="translate(30.000000, 286.000000)"><path d="M1.77556129,0 L20.1318194,0 L27.9943097,7.83196129 L27.9943097,34.1879484 C27.9943097,35.1525032 27.2122065,35.9337935 26.2484645,35.9337935 L1.77556129,35.9337935 C0.811819355,35.9337935 0.029716129,35.1525032 0.029716129,34.1879484 L0.029716129,1.74584516 C0.029716129,0.781290323 0.811909677,0 1.77556129,0 Z" id="Path" fill="#0263d1" fill-rule="nonzero"></path> <text id="PDF" font-family="Nunito-Black, Nunito" font-size="10" font-weight="700" line-spacing="16" fill="#FFFFFF"><tspan x="3.86" y="21">DOC</tspan></text> <path d="M27.9691097,7.85634839 L21.8838968,7.85634839 C20.9201548,7.85634839 20.1380516,7.07424516 20.1380516,6.11050323 L20.1380516,0.0174322581 L27.9691097,7.85634839 Z" id="Path" fill="#4e92df" fill-rule="nonzero"></path></g></g></g></svg>',
                    docx:
                        '<svg width="28px" height="36px" viewBox="0 0 28 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>FEBBB219-DE67-469C-8384-D2544C3723C4</title> <g id="Android-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="2020-05_diskuse-priloha" transform="translate(-30.000000, -286.000000)"><g id="file-extension" transform="translate(30.000000, 286.000000)"><path d="M1.77556129,0 L20.1318194,0 L27.9943097,7.83196129 L27.9943097,34.1879484 C27.9943097,35.1525032 27.2122065,35.9337935 26.2484645,35.9337935 L1.77556129,35.9337935 C0.811819355,35.9337935 0.029716129,35.1525032 0.029716129,34.1879484 L0.029716129,1.74584516 C0.029716129,0.781290323 0.811909677,0 1.77556129,0 Z" id="Path" fill="#0263d1" fill-rule="nonzero"></path> <text id="PDF" font-family="Nunito-Black, Nunito" font-size="10" font-weight="700" line-spacing="16" fill="#FFFFFF"><tspan x="3.86" y="21">DOC</tspan></text> <path d="M27.9691097,7.85634839 L21.8838968,7.85634839 C20.9201548,7.85634839 20.1380516,7.07424516 20.1380516,6.11050323 L20.1380516,0.0174322581 L27.9691097,7.85634839 Z" id="Path" fill="#4e92df" fill-rule="nonzero"></path></g></g></g></svg>',
                },
                ...options
            })
            .on('filebatchselected', function() {
                const filesToSubmit = $(this).parents('form').find('input[type=file]')

                filesToSubmit[0].files = new that.fileListItems(fileInput.fileinput('getFileList'))

                that.filesSizeLimit(filesToSubmit[0].files)
            })
            .on('fileremoved', function() {
                const filesToSubmit = $(this).parents('form').find('input[type=file]')

                filesToSubmit[0].files = new that.fileListItems(fileInput.fileinput('getFileList'))

                that.filesSizeLimit(filesToSubmit[0].files)
            })
    }

    fileListItems(files) {
        const b = new ClipboardEvent('').clipboardData || new DataTransfer()

        for (let i = 0, len = files.length; i < len; i++) {
            b.items.add(files[i])
        }

        return b.files
    }

    totalFilesSize(files) {
        let totalSize = 0
        let i = 0

        while (i < files.length) {
            totalSize += files[i].size
            i++
        }

        return totalSize
    }

    filesSizeLimit(files) {
        const limit = 10000000
        const size = this.totalFilesSize(files)

        const errorText = 'The file size is too large, the maximum size allowed is <b>10 MB</b>.'

        if (size > limit) {
            $('.kv-fileinput-error').show()
            if ($('.form-thread-create .file-input').length !== 0) {
                $('.form-thread-create .comment-user-input--buttons .file-button').addClass('disabled')
                $('.form-thread-create .comment-user-input--buttons .send-button').addClass('disabled')
            } else {
                $('.file-input ~ .comment-input-wrapper .comment-user-input--buttons .file-button').addClass('disabled')
                $('.file-input ~ .comment-input-wrapper .comment-user-input--buttons .send-button').addClass('disabled')
            }
            if ($('.kv-fileinput-error ul li').length === 0) {
                $('.kv-fileinput-error').html(
                    '<div><ul><li class="error-files-size">' + lang.get(errorText) + '</li></ul></div>'
                )
            } else if (!$('.kv-fileinput-error ul li').hasClass('error-files-size')) {
                $('.kv-fileinput-error ul').append('<li class="error-files-size">' + lang.get(errorText) + '</li>')
            }
        } else {
            $('.error-files-size').remove()
            if ($('.form-thread-create .file-input').length !== 0) {
                $('.form-thread-create .comment-user-input--buttons .comment-user-input--button').removeClass('disabled')
            } else {
                $('.file-input ~ .comment-input-wrapper .comment-user-input--buttons .comment-user-input--button').removeClass('disabled')
            }
            if ($('.kv-fileinput-error ul li').length === 0) {
                $('.kv-fileinput-error').hide()
            }
        }
    }

    prepareInitialPreview(files, deleteUrl) {
        const initialPreview = []
        const initialPreviewConfig = []

        files.each((i, file) => {
            const url = $(file).attr('href')

            const uri = new URI(url)
            const pathname = uri.pathname() 
            const filenameTemp = uri.filename()
            const filenameSplit = filenameTemp.split("?")

            const filename = filenameSplit[0]

            initialPreview.push(url)

            initialPreviewConfig.push({
                // size: iTime ? iTime.transferSize : 0,
                caption: filename,
                url: deleteUrl,
                extra: { path: pathname },
                type: !filename.endsWith('.pdf') ? 'image' : null
            })
        })

        return { initialPreview, initialPreviewConfig }
    }

    linkifyText() {
        $('.linkify-text').each(function(i, el) {
            const text = _.escape($(el).text())
            const linkedText = Autolinker.link(text, {
                newWindow: true
            })

            $(el).html(linkedText)
        })
    }

    parseCommentMentions() {
        $('.parse-mention').each(function(i, el) {
            // list of already replaced mentions
            const replaced = []

            // escape comment body once more
            let commentBody = _.escape($(el).text())

            // regex to match mentions format @(name) - name = user's name
            const regexMentions = /\((@[\w\s\dÀ-ž]+)\)/gm

            const matches = commentBody.match(regexMentions)

            // when zero matches continue to next comment
            if (!matches) {
                return
            }

            const singleMatch = /\((@[\w\s\dÀ-ž]+)\)/

            // go trough matches and parse them
            for (let i = 0; i < matches.length; i++) {
                const [match, mention] = singleMatch.exec(matches[i])

                // skip if already replaced
                if (replaced.indexOf(match) > -1) {
                    continue
                }

                // match = (@name) - eg. (@Kouč Jílek)
                // mention = @name - eg. @Kouč Jílek
                commentBody = commentBody.replaceAll(match, `<span>${mention}</span>`)

                // mark as replaced
                replaced.push(match)
            }

            // fix spaces
            commentBody = commentBody.replaceAll('&nbsp;', ' ')
            commentBody = commentBody.replaceAll('&amp;nbsp;', ' ')

            $(el).html(commentBody)
        })
    }

    registerMentions() {
        new Mentions({
            // Input element selector
            input: '.comment-input-wrapper .comment-user-input--text',

            // Current group id
            group_id: $('[name="group_id"]').val(),

            // Pools
            pools: [
                {
                    // Trigger the popup on the @ symbol
                    // Defaults to @
                    trigger: '@',

                    // Pool name from the mentions config
                    pool: 'users',

                    // Same value as the pool's 'column' value
                    display: 'fullname',

                    // The model's primary key field name
                    reference: 'id'
                }
            ]
        })
    }

    filterThreadsByOwnership() {
        if ($(this).prop('checked')) {
            $('.thread-list-aside .thread-wrapper').not('[data-owner="1"]').hide()
            $('.thread-list-main .thread-wrapper').not('[data-owner="1"]').hide()
        } else {
            $('.thread-list-aside .thread-wrapper').not('[data-owner="1"]').show()
            $('.thread-list-main .thread-wrapper').not('[data-owner="1"]').show()
        }
    }

    // show comments and mark related notifications to the thread as read
    openThread({ threadElement }) {
        threadElement = threadElement || $(this).parents('[data-thread]')
        const threadId = threadElement.data('thread')
        threadElement.addClass('thread-opened')
        threadElement.removeClass('thread-closed')

        threadElement.find('.comments-content').show()

        if (!isMobileViewport && threadElement.find('.thread-notification').length > 0) {
            axios.get(`/forum/diskuze/${threadId}/mark-as-read`)
        }
    }

    editThread(event, $el) {
        const button = $(event.relatedTarget) // button that triggered the modal
        const threadElement = button.parents('[data-thread]')
        const threadId = threadElement.data('thread')
        const form = $($el).find('form')
        const titleInput = form.find('[name="title"]')
        const bodyInput = form.find('[name="body"]')
        const fileInput = form.find('#files-edit-thread-modal')

        form.attr('action', `/forum/diskuze/${threadId}`)
        titleInput.val(threadElement.find('.thread-title').text())
        bodyInput.val(threadElement.find('.thread-body').text())

        const files = threadElement.find('.thread-file')

        this.createFileInput(fileInput, {
            ...this.prepareInitialPreview(
                files,
                `/forum/threads/${threadId}/file`
            ),
            initialPreviewAsData: true,
            overwriteInitial: false
        })
    }

    growThread(e) {
        const form = $(this).find('form')
        const titleInput = form.find('[name="title"]')
        const bodyInput = form.find('[name="body"]')

        titleInput.height(titleInput[0].scrollHeight - 32)
        bodyInput.height(bodyInput[0].scrollHeight - 32)
    }

    deleteThread(e) {
        const button = $(e.relatedTarget) // button that triggered the modal
        const threadElement = button.parents('[data-thread]')

        $(this)
            .find('form')
            .attr('action', `/forum/diskuze/${threadElement.data('thread')}`)
    }

    editComment(event, $el) {
        const button = $(event.relatedTarget) // button that triggered the modal
        const commentElement = button.parents('[data-comment]')
        const commentId = commentElement.data('comment')
        const form = $($el).find('form')
        const textarea = form.find('textarea')
        const fileInput = form.find('#files-edit-comment-modal')

        form.attr('action', `/forum/komentare/${commentId}`)
        textarea.val(commentElement.find('.comment-text p').text())

        const files = commentElement.find('.comment-file')

        this.createFileInput(fileInput, {
            ...this.prepareInitialPreview(
                files,
                `/forum/comments/${commentId}/file`
            ),
            initialPreviewAsData: true,
            overwriteInitial: false
        })
    }

    growComment(e) {
        const form = $(this).find('form')
        const textarea = form.find('textarea')

        textarea.height(textarea[0].scrollHeight - 32)
    }

    deleteComment(e) {
        const button = $(e.relatedTarget) // button that triggered the modal
        const commentElement = button.parents('[data-comment]')

        $(this)
            .find('form')
            .attr('action', `/forum/komentare/${commentElement.data('comment')}`)
    }

    toggleComments(e) {
        e.preventDefault()

        const allComments = $(this).parent().find('.all-comments-wrapper')
        const previewCommets = $(this).parent().find('.preview-comments-wrapper')

        allComments.toggle()
        previewCommets.toggle()

        if (allComments.is(':visible')) {
            $(this).text(
                $(this).text().replace(lang.get('Show all comments'), lang.get('Hide all comments'))
            )
        } else {
            $(this).text(
                $(this).text().replace(lang.get('Hide all comments'), lang.get('Show all comments'))
            )
        }
    }

    disableBtnOnSubmit() {
        const btn = $(this).find('button[type="submit"]').attr('disabled', true)

        const btnSend = $(this).find('button.btn-send span')

        setTimeout(() => {
            btnSend.after(`<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="spinner" class="svg-inline--fa fa-spinner fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"></path></svg>`)
        }, 0)
    }

    submitComment() {
        const btnSend = $(this).find('span')

        const replaced = []

        const textarea = $(this).parents('form').find('.comment-user-input--text')
        const textareaHidden = $(this).parents('form').find('input[name=body]')
        const file = $(this).parents('form').find('input[type=file]')

        // escape comment body once more
        let textareaBody = textarea.html()

        // regex to match mentions format @(name) - name = user's name
        const regexMentions = /\<span contenteditable="false">(@[\w\s\dÀ-ž]+)\<\/span>/gm

        const matches = textareaBody.match(regexMentions)
        const singleMatch = /\<span contenteditable="false">(@[\w\s\dÀ-ž]+)\<\/span>/

        if (matches) {
            for (let i = 0; i < matches.length; i++) {
                const [match, mention] = singleMatch.exec(matches[i])

                // skip if already replaced
                if (replaced.indexOf(match) > -1) {
                    continue
                }

                // match = (@name) - eg. (@Kouč Jílek)
                // mention = @name - eg. @Kouč Jílek
                textareaBody = textareaBody.replaceAll(match, `(${mention})`)

                // mark as replaced
                replaced.push(match)
            }
        }

        // fix spaces
        textareaBody = textareaBody.replaceAll('&nbsp;', ' ')
        textareaBody = textareaBody.replaceAll('&amp;nbsp;', ' ')
        textareaBody = textareaBody.replaceAll('<div>', '\n')
        textareaBody = textareaBody.replace(/(<([^>]+)>)/ig, '')

        textareaHidden.val(_.escape(textareaBody))

        if (file.val() != '' || textareaHidden.val() != '') {
            $(this).attr('disabled', true)

            setTimeout(() => {
                btnSend.after(`<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="spinner" class="svg-inline--fa fa-spinner fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"></path></svg>`)
            }, 0)

            $(this).parents('form').submit()
        } else {
            return false
        }
    }

    clickOnNotification(e) {
        const target = $(e.currentTarget).data('target')
        const additionalTarget = $(e.currentTarget).data('additional-target')

        this.scrollTo(target, additionalTarget)
    }

    openThreadDetail() {
        if (isMobileViewport) {
            const threadElement = $(this).parents('[data-thread]')
            const threadId = threadElement.data('thread')

            location.href = `/forum/diskuze/${threadId}`
        }
    }

    scrollTo(target, additionaltarget = null) {
        if (!target) return

        const [model, id] = target.split('-')

        if (model === 'thread') {
            this.jumpToThread({ target })
        } else if (model === 'comment') {
            this.jumpToThread({ target: additionaltarget, skipScroll: true, showAllComments: true })

            const commentElement = $(`[data-comment="${id}"]`).first()

            setTimeout(() => {
                this.elementToScrollTo(commentElement)
            }, 0)
        }
    }

    jumpToThread({ target, skipScroll, showAllComments }) {
        const [model, id] = target.split('-')

        const threadElement = $(`[data-thread="${id}"]`)
        this.openThread({ threadElement })

        // if more then 5 comments, show all comments
        if (
            showAllComments &&
            threadElement.find('.all-comments') &&
            threadElement.find('.all-comments-wrapper').is(':hidden')
        ) {
            setTimeout(() => {
                threadElement.find('.all-comments').click()
            }, 0)
        }

        if (!skipScroll) {
            this.elementToScrollTo(threadElement)
        }
    }

    elementToScrollTo(target, additionalOffset = -360) {
        $([document.documentElement, document.body]).animate(
            {
                scrollTop: target.offset().top + additionalOffset
            },
            0
        )
    }
}

export default new Forum()
